module.exports = __webpack_public_path__ + "static/img/loading.eb38500.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/universal/emptyPlacehold/loading.gif
// module id = THok
// module chunks = 9